import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Component selector, template and style
 */
@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss']
})

/**
 * Navigation item component
 */
export class NavigationItemComponent {
  /**
   * Item's icon class string (i.e. `sliders-h`)
   */
  @Input() public icon!: string;

  /**
   * Additional icon to place over the item's icon
   */
  @Input() public extra!: string | undefined;

  /**
   * Item's text
   */
  @Input() public text!: string;

  /**
   * Route to follow when clicking on the icon
   */
  @Input() public link!: string;

  /**
   * Item's direction
   */
  @Input() public direction!: 'row' | 'column';

  /**
   * Display mode. Can be either: "full" or "compact"
   */
  @Input() public mode!: 'compact' | 'full';

  /**
   * Whether the menu item is active
   */
  @Input() public active!: boolean;

  /**
   * Click callback
   */
  @Output() public clickCallback: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Emit when the item is clicked
   */
  elementClicked(): void {
    this.clickCallback.emit(this);
  }
}
